import { defineMessages } from 'react-intl';

export default defineMessages({
    approve: {
        id: 'quoteandbind.custom.common.views.quote-details.underwriting-issue.action.Approve',
        defaultMessage: 'Approve'
    },
    blocksBind: {
        id: 'quoteandbind.custom.directives.MultiQuoteView.Blocks bind',
        defaultMessage: 'Blocks bind'
    },
    blocksQuote: {
        id: 'quoteandbind.custom.directives.MultiQuoteView.Blocks quote',
        defaultMessage: 'Blocks quote'
    },
    blocksQuoteRelease: {
        id: 'quoteandbind.custom.directives.MultiQuoteView.Blocks quote release',
        defaultMessage: 'Blocks quote release'
    },
    weCannotShow: {
        id: 'quoteandbind.custom.common.views.quote-details.We cannot show a quote because it has underwriting issues',
        defaultMessage: 'We cannot show a quote because it has underwriting issues'
    },
    followingQuotes: {
        id: 'quoteandbind.custom.common.views.quote-details.Underwriting issues have been raised for the following quotes:',
        defaultMessage: 'Underwriting issues have been raised for the following quotes:'
    },
    nonBlocking: {
        id: 'quoteandbind.custom.directives.MultiQuoteView.Non-blocking',
        defaultMessage: 'Non-blocking'
    },
    policyChangeNoteInfoUW: {
        id: 'gateway.views.job-uwissues.policyChangeNoteInfoUW',
        defaultMessage: 'Please enter detailed notes for the underwriter describing all changes that have been completed in this transaction.'
    },
    submissionNoteInfoUW: {
        id: 'gateway.views.job-uwissues.submissionNoteInfoUW',
        defaultMessage: 'Please enter additional information for the underwriter regarding this new policy.'
    },
    confirmationOfSignAndDoc: {
        id: 'quoteandbind.custom.directives.Please confirm collection of all signatures and relevant documentation prior to issuing',
        defaultMessage: 'Please confirm collection of all signatures and relevant documentation prior to issuing',
    },
    brokerDeclaration: {
        id: 'quoteandbind.custom.directives.Broker Declaration',
        defaultMessage: 'Broker Declaration',
    },
    laterPolicyRenewal: {
        id: 'gateway.views.job-uwissues.There is a later policy renewal. Apply this Policy Change to that renewal and view the renewal?',
        defaultMessage: 'There is a later policy renewal. Apply this Policy Change to that renewal and view the renewal?'
    },
    payUsingBAError: {
        id: 'gateway.views.job-uwissues.Please select a Preauthorized Bank Account for payment',
        defaultMessage: 'Please select a Preauthorized Bank Account for payment'
    },
    modelError: {
        id: 'gateway.views.job-uwissues.Error',
        defaultMessage: 'Error'
    },
    paymentInstInfo: {
        id: 'quoteandbind.common.views.quote-details.Please confirm the last 4 digits of the bank account or credit card, as well as the withdrawal date in the referral note.',
        defaultMessage: 'Please confirm the last 4 digits of the bank account or credit card, as well as the withdrawal date in the referral note.'
    }
});
